// Shared deposit-card UI — the SINGLE SOURCE OF TRUTH for the cross-chain
// "bridge funds in" entry and the "how to get USDC/HYPE on HyperEVM" help tip.
//
// The /deposit page (deposit.js) and the per-vault detail page (vault-detail.js)
// BOTH render from here, so they can never drift apart again. They did drift
// (2026-06-15): the /deposit page had the zap while the detail page still pointed
// users at the old manual "Transfer to EVM" path and had no bridge entry at all.
// Neither page hardcodes this copy now — change it here, both update.

import { openZapWizard } from './zap-ui.js';

// Hyperliquid's native Core→EVM transfer — the SECONDARY path, for users who
// already hold USDC on the Hyperliquid exchange. The zap is the primary path.
export const HYPE_BRIDGE_URL = "https://app.hyperliquid.xyz/portfolio";

// The cross-chain "bridge funds in" entry button. `id` is page-specific (each
// page passes its own); call wireZapEntry(id) after render to attach the handler.
export function zapEntryHtml(id = 'dep-zap-btn') {
  return `<button id="${id}" type="button" class="text-[0.7rem] mb-4 text-primary/80 hover:text-primary flex items-center gap-1 transition-colors">
    <span class="material-symbols-outlined" style="font-size:14px;line-height:1;">bolt</span>
    Funds on another chain? Bridge them in →
  </button>`;
}
export function wireZapEntry(id = 'dep-zap-btn') {
  document.getElementById(id)?.addEventListener('click', () => openZapWizard());
}

// Contextual help when a wallet can't deposit yet. Leads with the ZAP (works from
// any chain, includes a HYPE gas top-up); demotes Hyperliquid's "Transfer to EVM"
// to a parenthetical for HL-native users. Returns an HTML string, or null.
export function usdcHelpTip({ noUsdc, lowHype }) {
  const hlLink = `<a href="${HYPE_BRIDGE_URL}" target="_blank" rel="noopener" class="text-primary underline">Hyperliquid</a>`;
  if (noUsdc && lowHype) {
    return `<span class="text-on-surface font-semibold">No USDC or HYPE on HyperEVM yet.</span> `
      + `Bridge USDC in from any chain with the button below — it includes a little HYPE for gas. `
      + `(Already on ${hlLink}? Use "Transfer to EVM" instead.)`;
  }
  if (noUsdc) {
    return `<span class="text-on-surface font-semibold">No USDC on HyperEVM yet.</span> `
      + `Bridge it in from any chain with the button below. `
      + `(Already hold USDC on ${hlLink}? Use its "Transfer to EVM".)`;
  }
  if (lowHype) {
    return `<span class="text-on-surface font-semibold">Low HYPE for gas.</span> `
      + `HyperEVM transactions cost ~0.001 HYPE each — bridging in (button below) includes a gas top-up, `
      + `or transfer some via the ${hlLink} portfolio.`;
  }
  return null;
}
